import React, { useEffect, useRef } from 'react'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { Card, Grid, Button, Form, Input, Message, Table, Pagination, Loader } from 'semantic-ui-react';
import DatePicker from "react-datepicker";
import { searchService } from '../services';
import { ApiResponse, RequestPayload } from '../services/ApiClient/types';
import { OnDemandSearchResult, RouteStopSearchResult, searchDates, SearchQueryParams, SearchRef, searchResults, SearchView, setPage } from '../services/SearchService/types';
import '../styles/AdvanceSearch.scss'
import moment from 'moment';
import { updateMessage, updateSearchValue, setFromDate, setToDate } from '../components/FetchStore/AdvanceSearchSlice'
import { useDispatch, useSelector } from 'react-redux';
import { formatDate } from '../utils/datehelper';

type Props = {}

interface style {
    headerCell: React.CSSProperties,
    tCell: React.CSSProperties
}
type RouteStopSearchResultKeys = keyof RouteStopSearchResult
type OnDemandSearchResultKeys = keyof OnDemandSearchResult


const style: style = {
    headerCell: {
        backgroundColor: "#2d8fc4",
        color: "white",
        border: "0.5px solid #ddd",
        fontSize: '1rem',
        textAlign: 'center',
        whiteSpace: 'pre-line',
    },
    tCell: {
        fontSize: '1rem',
        textAlign: 'center',
    },

}
const defaultRouteStopView: RouteStopSearchResult = {
    id: 0,
    courierName: 'string',
    status: 'string',
    podText: 'string',
    reference: 'string',
    name: 'string',
    address1: 'string',
    address2: 'string',
    city: 'string',
    state: 'string',
    zip: 'string',
    reference1: 'string',
    reference2: 'string',
    postDate: new Date()
}


const routeStopViewHeaders: RouteStopSearchResultKeys[] = Object.keys(defaultRouteStopView) as RouteStopSearchResultKeys[];

const defaultOnDemandSearchResults: OnDemandSearchResult = {
    fgOrderId: 0,
    courierName: 'string',
    status: 'string',
    trackingNumber: 'string',
    originName: 'string',
    originAddress: 'string',
    originCity: 'string',
    originState: 'string',
    originZip: 'string',
    destName: 'string',
    destAddress: 'string',
    destCity: 'string',
    destState: 'string',
    destZip: 'string',
    destComments: 'string',
    reference1: 'string',
    reference2: 'string',
    userData1: 'string',
    orderDate: new Date()
}

const onDemandViewHeaders: OnDemandSearchResultKeys[] = Object.keys(defaultOnDemandSearchResults) as OnDemandSearchResultKeys[];
const headerFix = (header: string | number) => {
    if (typeof header === 'number') {
        return header
    } else {
        return `${header.replace(/^./, m => m.toUpperCase())}`;
    };
}



const AdvanceSearch = (props: Props) => {
    const navigate = useNavigate();
    const [messageVisible, setMessageVisible] = useState<boolean>(false);
    const [searchValue, setSearchValue] = useState<string | null>(null)
    const [searchDates, setSearchDates] = useState<searchDates>({ fromDate: moment(new Date()).subtract(7, 'days').toDate(), toDate: new Date() })
    const [searchResults, setSearchResults] = useState<SearchView | null>(null)
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [errorMsg, setErrorMsg] = useState<ApiResponse<any> | null>(null)
    const [currentPage, setCurrentPage] = useState<setPage>({ stops: 1, onDemand: 1 });

    const [itemsPerPage,] = useState<number>(25);



    const advanceSearchRef = useRef<SearchRef>({
        searchValue: null,
        fromDate: moment(new Date()).subtract(7, 'days').toDate(),
        toDate: new Date(),
    })

    const { fromDate, toDate } = useSelector((state: any) => state.advSearch)
    const dispatcher = useDispatch()

    useEffect(() => {
        if (localStorage.token === null || localStorage.token === undefined) {
            const navTo = `/`
            navigate(navTo)
        }
        localStorage.setItem('route', "Search")
    }, [])


    const customSearch = () => {
        try {
            let query: SearchQueryParams = {
                // searchCriteria: searchValue,
                searchCriteria: advanceSearchRef.current.searchValue,
                // fromDate: searchDates.fromDate.toDateString(),
                fromDate: fromDate,
                // toDate: searchDates.toDate.toDateString(),
                toDate: toDate,
            }
            let payload: RequestPayload<null> = {
                queryParams: query, payload: null
            }
            setIsLoading(true)
            searchService.GetTrackingInfo(payload)
                .then(response => {
                    if (response.success) {
                        setSearchResults(response.result)
                        setIsLoading(false)
                    } else if (response.success === false) {
                        setErrorMsg(response)
                        setIsLoading(false)
                    }
                    setIsLoading(false)
                })
        } catch (err) {
            console.log("A error has occurred:", err)
        }
    }
    const handlePageChange = (e: any, { activePage }: any) => {
        setCurrentPage({ ...activePage });
    }
    let currentPageStopData: RouteStopSearchResult[] = searchResults?.routeStopSearchResults?.slice((currentPage.stops - 1) * itemsPerPage, currentPage.stops * itemsPerPage);
    let currentPageOnDemandData: OnDemandSearchResult[] = searchResults?.onDemandSearchResults?.slice((currentPage.onDemand - 1) * itemsPerPage, currentPage.onDemand * itemsPerPage);

    return (
        <div className="search-container">
            <div className='search-wrapper'>
                {!isLoading ? <Card className='search-card'>
                    <Card.Content id="search-content">
                        <Grid>
                            <Grid.Row columns={2} id="search-grid-row">
                                <Grid.Column width={5}>
                                    <Form.Field >
                                        {/* <Input id='search-input' icon='search' placeholder={'Search...'} value={searchValue} onChange={(e: React.ChangeEvent<HTMLInputElement>) => setSearchValue(e.target.value)} /> */}
                                        <Input id='search-input' icon='search' placeholder={'Search...'} onChange={(e: React.ChangeEvent<HTMLInputElement>) => advanceSearchRef.current.searchValue = e.target.value} />
                                    </Form.Field>
                                </Grid.Column>
                                <Grid.Column width={11}>
                                    {/* <Button disabled={!searchValue} primary color='blue' id="search-button" onClick={() => customSearch()}> */}
                                    <Button disabled={!advanceSearchRef.current.searchValue} primary color='blue' id="search-button" onClick={() => customSearch()}>
                                        Search
                                    </Button>
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </Card.Content>
                    <Card.Content>
                        {messageVisible ?
                            <Message
                                error
                                header='Not Found'
                                content={'No Route(s) or On Demand Stop(s) were found matching your criteria.'}
                                onDismiss={() => setMessageVisible(false)}
                            /> : ""
                        }
                        <Form>
                            <Form.Group>
                                <Form.Field
                                    control={Input}
                                    label='From Date'
                                    placeholder='MM/DD/YYYY'
                                >
                                    <DatePicker
                                        onChange={(date: any) => dispatcher(setFromDate(date))}
                                        selected={fromDate}
                                    />
                                </Form.Field>
                                <Form.Field
                                    control={Input}
                                    label='To Date'
                                    placeholder='MM/DD/YYYY'
                                >
                                    <DatePicker
                                        minDate={fromDate}
                                        selected={toDate}
                                        onChange={(date: any) => dispatcher(setToDate(date))}
                                    />
                                </Form.Field>
                            </Form.Group>
                        </Form>
                    </Card.Content>
                </Card>
                    : <Loader size='massive' active={isLoading} />}

                {errorMsg && `Error: ${errorMsg?.message}`}
                {searchResults?.routeStopSearchResults?.length > 0 && !isLoading && <>
                    <h3>Route stops</h3>
                    <Table>
                        <Table.Header>
                            <Table.Row>
                                {routeStopViewHeaders.map((header: string | number, idx: number) => {
                                    return (
                                        <Table.HeaderCell style={style.headerCell} key={idx}>{headerFix(header)}</Table.HeaderCell>
                                    )
                                })}
                            </Table.Row>
                        </Table.Header>
                        {currentPageStopData.map((row: RouteStopSearchResult | number, idx: number) => {
                            return (
                                <Table.Row>
                                    {
                                        Object.entries(row || []).map(([key, value]: any) => {
                                            return (
                                                <Table.Cell style={style.tCell}>{value === null || value === undefined ? "N/A" : value}</Table.Cell>
                                            )
                                        })
                                    }
                                </Table.Row>
                            )
                        }
                        )
                        }
                    </Table>
                    <Pagination
                        activePage={currentPage.stops}
                        onPageChange={(e, activePage: any) => setCurrentPage({ ...currentPage, stops: activePage.activePage })}
                        siblingRange={1}
                        pointing
                        secondary
                        totalPages={Math.ceil(searchResults?.routeStopSearchResults?.length / itemsPerPage)}
                    />
                </>
                }
                {searchResults?.routeStopSearchResults?.length === 0 ? searchResults?.onDemandSearchResults?.length === 0 ? <><h1>No results found</h1></> : <><h1>No Routes found</h1></> : null}
                {
                    searchResults?.onDemandSearchResults?.length > 0 &&
                    <>
                        <h3>On Demand</h3>
                        <Table>
                            <Table.Header>
                                <Table.Header>
                                    <Table.Row>
                                        {onDemandViewHeaders.map((header: string | number, idx: number) => {
                                            return (
                                                <Table.HeaderCell style={style.headerCell} key={idx}>{header}</Table.HeaderCell>
                                            )
                                        })}
                                    </Table.Row>
                                </Table.Header>
                            </Table.Header>
                            {currentPageOnDemandData.map((row: any | number, idx: number) => {
                                return (
                                    <Table.Row key={idx}>
                                        {
                                            Object.values(row).map((rowData: any | number, idx: number) => {
                                                return (
                                                    <Table.Cell style={style.tCell} key={idx}>{rowData}</Table.Cell>
                                                )
                                            })
                                        }
                                    </Table.Row>
                                )
                            }
                            )
                            }
                        </Table>
                        <Pagination
                            activePage={currentPage.onDemand}
                            onPageChange={(e, activePage: any) => setCurrentPage({ ...currentPage, onDemand: activePage.activePage })}
                            siblingRange={1}
                            pointing
                            secondary
                            totalPages={Math.ceil(searchResults?.routeStopSearchResults?.length / itemsPerPage)}
                        />
                    </>
                }
            </div>
        </div>
    )
}

export default AdvanceSearch